<template>
	<div 
    v-if="toggle == 'on'" 
    id="livestream" 
    :class="location === 'Radical Broadcast' || location === 'Full Screen' ? 'also-in-rb' : 'draggable'" 
    :style="[location === 'Full Screen' ? 'position: fixed' : null, embedLink.length > 0 && 'height: 0px; padding-bottom: 56.25%']"
  >
		<iframe 
      :src="embed" 
      width="100%" 
      height="100%" 
      frameborder="0" 
      allowfullscreen 
      :allow="embedLink.length && 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'"
      :title="embedLink.length && 'YouTube video player'"
      style="pointer-events:all;min-width:100%;min-height:100%; object-fit: contain;"></iframe>
 	</div>
</template>


<script>
import interact from 'interactjs'

export default {
  name: 'Livestream',
  data () {
	  return {
		  toggle: '',
		  id: '',
      location: '',
      embedLink: ''
	  };
  },
  methods: {
	  getContent () {
		  this.$prismic.client.getSingle('homepage')
		  	.then((document) => {
          this.toggle = document.data.livestream
          // this.toggle = 'on';
			  	this.id = document.data.livestream_id,
          this.location = document.data.livestreamlocation
          // this.location = "Radical Broadcast"
          this.embedLink = document.data.embed_link
		  	})
	  }
  },
  created () {
	  this.getContent();
  },
  mounted () {
  },
  computed: {
	  embed () {
      if (this.embedLink.length) return this.embedLink + '?&showinfo=0&rel=0&modestbranding=1';
		  return 'https://player.vimeo.com/video/' + this.id
	  }
  },
  watch: {
  }
}

interact('.draggable')
  .draggable({
    inertia: true,
    // keep the element within the area of it's parent
    // enable autoScroll
    autoScroll: true,

    // call this function on every dragmove event
    onmove: dragMoveListener
   });

  function dragMoveListener (event) {
    var target = event.target,
        // keep the dragged position in the data-x/data-y attributes
        x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
        y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

    // translate the element
    target.style.webkitTransform =
    target.style.transform =
      'translate(' + x + 'px, ' + y + 'px)';

    // update the posiion attributes
    target.setAttribute('data-x', x);
    target.setAttribute('data-y', y);
  }

  // this is used later in the resizing and gesture demos
  window.dragMoveListener = dragMoveListener;
  
</script>